import cx from 'clsx';
import type { FC } from 'react';

import styles from './styles.module.scss';
import type { Props } from './types';

export const PillCheckbox: FC<Props> = ({
  name,
  value,
  checked,
  className,
  textClassName,
  onChange,
}) => {
  const handleClick = () => {
    onChange?.({ name, value, checked: !checked });
  };

  return (
    <button
      className={cx(
        styles.containerRoot,
        checked && styles.isChecked,
        className,
      )}
      value={value}
      onClick={handleClick}>
      {checked && (
        <svg
          fill="none"
          height="8"
          viewBox="0 0 11 8"
          width="11"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 3.86041C0.0520528 3.74852 0.086792 3.62357 0.159302 3.52702C0.476105 3.10499 1.02333 3.08338 1.41155 3.47063C2.12464 4.18196 2.83642 4.89468 3.54808 5.60749C3.57578 5.63525 3.59677 5.66968 3.62532 5.70669C3.66861 5.66583 3.69691 5.64047 3.72374 5.61362C5.38108 3.95652 7.03869 2.29971 8.69491 0.641491C8.88658 0.449566 9.10714 0.339057 9.3831 0.36577C9.69533 0.395967 9.91867 0.560813 10.0443 0.84278C10.1657 1.11541 10.1316 1.38258 9.96147 1.62873C9.92433 1.68247 9.87851 1.73107 9.83215 1.77748C7.9729 3.63772 6.1129 5.49711 4.25397 7.3576C4.00416 7.60761 3.71262 7.70777 3.37479 7.58679C3.25252 7.54305 3.13374 7.4609 3.04067 7.36871C2.11257 6.4488 1.19082 5.52243 0.265238 4.59993C0.133199 4.46831 0.0560608 4.30979 0 4.13694V3.86041Z" // @suppress longLineCheck
            fill="black"
            id="Path 42" />
        </svg>
      )}
      <span className={textClassName}>
        {name}
      </span>
    </button>
  );
};
